export const icon_list =

    [
        {
            "name": "activity icon",
            "value": "ActivityIcon"
        },
        {
            "name": "airplay icon",
            "value": "AirplayIcon"
        },
        {
            "name": "alert circle icon",
            "value": "AlertCircleIcon"
        },
        {
            "name": "alert octagon icon",
            "value": "AlertOctagonIcon"
        },
        {
            "name": "alert triangle icon",
            "value": "AlertTriangleIcon"
        },
        {
            "name": "align center icon",
            "value": "AlignCenterIcon"
        },
        {
            "name": "align justify icon",
            "value": "AlignJustifyIcon"
        },
        {
            "name": "align left icon",
            "value": "AlignLeftIcon"
        },
        {
            "name": "align right icon",
            "value": "AlignRightIcon"
        },
        {
            "name": "anchor icon",
            "value": "AnchorIcon"
        },
        {
            "name": "aperture icon",
            "value": "ApertureIcon"
        },
        {
            "name": "archive icon",
            "value": "ArchiveIcon"
        },
        {
            "name": "arrow down circle icon",
            "value": "ArrowDownCircleIcon"
        },
        {
            "name": "arrow down left icon",
            "value": "ArrowDownLeftIcon"
        },
        {
            "name": "arrow down right icon",
            "value": "ArrowDownRightIcon"
        },
        {
            "name": "arrow down icon",
            "value": "ArrowDownIcon"
        },
        {
            "name": "arrow left circle icon",
            "value": "ArrowLeftCircleIcon"
        },
        {
            "name": "arrow left icon",
            "value": "ArrowLeftIcon"
        },
        {
            "name": "arrow right circle icon",
            "value": "ArrowRightCircleIcon"
        },
        {
            "name": "arrow right icon",
            "value": "ArrowRightIcon"
        },
        {
            "name": "arrow up circle icon",
            "value": "ArrowUpCircleIcon"
        },
        {
            "name": "arrow up left icon",
            "value": "ArrowUpLeftIcon"
        },
        {
            "name": "arrow up right icon",
            "value": "ArrowUpRightIcon"
        },
        {
            "name": "arrow up icon",
            "value": "ArrowUpIcon"
        },
        {
            "name": "at sign icon",
            "value": "AtSignIcon"
        },
        {
            "name": "award icon",
            "value": "AwardIcon"
        },
        {
            "name": "bar chart 2 icon",
            "value": "BarChart2Icon"
        },
        {
            "name": "bar chart icon",
            "value": "BarChartIcon"
        },
        {
            "name": "battery charging icon",
            "value": "BatteryChargingIcon"
        },
        {
            "name": "battery icon",
            "value": "BatteryIcon"
        },
        {
            "name": "bell off icon",
            "value": "BellOffIcon"
        },
        {
            "name": "bell icon",
            "value": "BellIcon"
        },
        {
            "name": "bluetooth icon",
            "value": "BluetoothIcon"
        },
        {
            "name": "bold icon",
            "value": "BoldIcon"
        },
        {
            "name": "book open icon",
            "value": "BookOpenIcon"
        },
        {
            "name": "book icon",
            "value": "BookIcon"
        },
        {
            "name": "bookmark icon",
            "value": "BookmarkIcon"
        },
        {
            "name": "box icon",
            "value": "BoxIcon"
        },
        {
            "name": "briefcase icon",
            "value": "BriefcaseIcon"
        },
        {
            "name": "calendar icon",
            "value": "CalendarIcon"
        },
        {
            "name": "camera off icon",
            "value": "CameraOffIcon"
        },
        {
            "name": "camera icon",
            "value": "CameraIcon"
        },
        {
            "name": "cast icon",
            "value": "CastIcon"
        },
        {
            "name": "check circle icon",
            "value": "CheckCircleIcon"
        },
        {
            "name": "check square icon",
            "value": "CheckSquareIcon"
        },
        {
            "name": "check icon",
            "value": "CheckIcon"
        },
        {
            "name": "chevron down icon",
            "value": "ChevronDownIcon"
        },
        {
            "name": "chevron left icon",
            "value": "ChevronLeftIcon"
        },
        {
            "name": "chevron right icon",
            "value": "ChevronRightIcon"
        },
        {
            "name": "chevron up icon",
            "value": "ChevronUpIcon"
        },
        {
            "name": "chevrons down icon",
            "value": "ChevronsDownIcon"
        },
        {
            "name": "chevrons left icon",
            "value": "ChevronsLeftIcon"
        },
        {
            "name": "chevrons right icon",
            "value": "ChevronsRightIcon"
        },
        {
            "name": "chevrons up icon",
            "value": "ChevronsUpIcon"
        },
        {
            "name": "chrome icon",
            "value": "ChromeIcon"
        },
        {
            "name": "circle icon",
            "value": "CircleIcon"
        },
        {
            "name": "clipboard icon",
            "value": "ClipboardIcon"
        },
        {
            "name": "clock icon",
            "value": "ClockIcon"
        },
        {
            "name": "cloud drizzle icon",
            "value": "CloudDrizzleIcon"
        },
        {
            "name": "cloud lightning icon",
            "value": "CloudLightningIcon"
        },
        {
            "name": "cloud off icon",
            "value": "CloudOffIcon"
        },
        {
            "name": "cloud rain icon",
            "value": "CloudRainIcon"
        },
        {
            "name": "cloud snow icon",
            "value": "CloudSnowIcon"
        },
        {
            "name": "cloud icon",
            "value": "CloudIcon"
        },
        {
            "name": "code icon",
            "value": "CodeIcon"
        },
        {
            "name": "codepen icon",
            "value": "CodepenIcon"
        },
        {
            "name": "codesandbox icon",
            "value": "CodesandboxIcon"
        },
        {
            "name": "coffee icon",
            "value": "CoffeeIcon"
        },
        {
            "name": "columns icon",
            "value": "ColumnsIcon"
        },
        {
            "name": "command icon",
            "value": "CommandIcon"
        },
        {
            "name": "compass icon",
            "value": "CompassIcon"
        },
        {
            "name": "copy icon",
            "value": "CopyIcon"
        },
        {
            "name": "corner down left icon",
            "value": "CornerDownLeftIcon"
        },
        {
            "name": "corner down right icon",
            "value": "CornerDownRightIcon"
        },
        {
            "name": "corner left down icon",
            "value": "CornerLeftDownIcon"
        },
        {
            "name": "corner left up icon",
            "value": "CornerLeftUpIcon"
        },
        {
            "name": "corner right down icon",
            "value": "CornerRightDownIcon"
        },
        {
            "name": "corner right up icon",
            "value": "CornerRightUpIcon"
        },
        {
            "name": "corner up left icon",
            "value": "CornerUpLeftIcon"
        },
        {
            "name": "corner up right icon",
            "value": "CornerUpRightIcon"
        },
        {
            "name": "cpu icon",
            "value": "CpuIcon"
        },
        {
            "name": "credit card icon",
            "value": "CreditCardIcon"
        },
        {
            "name": "crop icon",
            "value": "CropIcon"
        },
        {
            "name": "crosshair icon",
            "value": "CrosshairIcon"
        },
        {
            "name": "database icon",
            "value": "DatabaseIcon"
        },
        {
            "name": "delete icon",
            "value": "DeleteIcon"
        },
        {
            "name": "disc icon",
            "value": "DiscIcon"
        },
        {
            "name": "divide circle icon",
            "value": "DivideCircleIcon"
        },
        {
            "name": "divide square icon",
            "value": "DivideSquareIcon"
        },
        {
            "name": "divide icon",
            "value": "DivideIcon"
        },
        {
            "name": "dollar sign icon",
            "value": "DollarSignIcon"
        },
        {
            "name": "download cloud icon",
            "value": "DownloadCloudIcon"
        },
        {
            "name": "download icon",
            "value": "DownloadIcon"
        },
        {
            "name": "dribbble icon",
            "value": "DribbbleIcon"
        },
        {
            "name": "droplet icon",
            "value": "DropletIcon"
        },
        {
            "name": "edit 2 icon",
            "value": "Edit2Icon"
        },
        {
            "name": "edit 3 icon",
            "value": "Edit3Icon"
        },
        {
            "name": "edit icon",
            "value": "EditIcon"
        },
        {
            "name": "external link icon",
            "value": "ExternalLinkIcon"
        },
        {
            "name": "eye off icon",
            "value": "EyeOffIcon"
        },
        {
            "name": "eye icon",
            "value": "EyeIcon"
        },
        {
            "name": "facebook icon",
            "value": "FacebookIcon"
        },
        {
            "name": "fast forward icon",
            "value": "FastForwardIcon"
        },
        {
            "name": "feather icon",
            "value": "FeatherIcon"
        },
        {
            "name": "figma icon",
            "value": "FigmaIcon"
        },
        {
            "name": "file minus icon",
            "value": "FileMinusIcon"
        },
        {
            "name": "file plus icon",
            "value": "FilePlusIcon"
        },
        {
            "name": "file text icon",
            "value": "FileTextIcon"
        },
        {
            "name": "file icon",
            "value": "FileIcon"
        },
        {
            "name": "film icon",
            "value": "FilmIcon"
        },
        {
            "name": "filter icon",
            "value": "FilterIcon"
        },
        {
            "name": "flag icon",
            "value": "FlagIcon"
        },
        {
            "name": "folder minus icon",
            "value": "FolderMinusIcon"
        },
        {
            "name": "folder plus icon",
            "value": "FolderPlusIcon"
        },
        {
            "name": "folder icon",
            "value": "FolderIcon"
        },
        {
            "name": "framer icon",
            "value": "FramerIcon"
        },
        {
            "name": "frown icon",
            "value": "FrownIcon"
        },
        {
            "name": "gift icon",
            "value": "GiftIcon"
        },
        {
            "name": "git branch icon",
            "value": "GitBranchIcon"
        },
        {
            "name": "git commit icon",
            "value": "GitCommitIcon"
        },
        {
            "name": "git merge icon",
            "value": "GitMergeIcon"
        },
        {
            "name": "git pull request icon",
            "value": "GitPullRequestIcon"
        },
        {
            "name": "github icon",
            "value": "GithubIcon"
        },
        {
            "name": "gitlab icon",
            "value": "GitlabIcon"
        },
        {
            "name": "globe icon",
            "value": "GlobeIcon"
        },
        {
            "name": "grid icon",
            "value": "GridIcon"
        },
        {
            "name": "hard drive icon",
            "value": "HardDriveIcon"
        },
        {
            "name": "hash icon",
            "value": "HashIcon"
        },
        {
            "name": "headphones icon",
            "value": "HeadphonesIcon"
        },
        {
            "name": "heart icon",
            "value": "HeartIcon"
        },
        {
            "name": "help circle icon",
            "value": "HelpCircleIcon"
        },
        {
            "name": "hexagon icon",
            "value": "HexagonIcon"
        },
        {
            "name": "home icon",
            "value": "HomeIcon"
        },
        {
            "name": "image icon",
            "value": "ImageIcon"
        },
        {
            "name": "inbox icon",
            "value": "InboxIcon"
        },
        {
            "name": "info icon",
            "value": "InfoIcon"
        },
        {
            "name": "instagram icon",
            "value": "InstagramIcon"
        },
        {
            "name": "italic icon",
            "value": "ItalicIcon"
        },
        {
            "name": "key icon",
            "value": "KeyIcon"
        },
        {
            "name": "layers icon",
            "value": "LayersIcon"
        },
        {
            "name": "layout icon",
            "value": "LayoutIcon"
        },
        {
            "name": "life buoy icon",
            "value": "LifeBuoyIcon"
        },
        {
            "name": "link 2 icon",
            "value": "Link2Icon"
        },
        {
            "name": "link icon",
            "value": "LinkIcon"
        },
        {
            "name": "linkedin icon",
            "value": "LinkedinIcon"
        },
        {
            "name": "list icon",
            "value": "ListIcon"
        },
        {
            "name": "loader icon",
            "value": "LoaderIcon"
        },
        {
            "name": "lock icon",
            "value": "LockIcon"
        },
        {
            "name": "log in icon",
            "value": "LogInIcon"
        },
        {
            "name": "log out icon",
            "value": "LogOutIcon"
        },
        {
            "name": "mail icon",
            "value": "MailIcon"
        },
        {
            "name": "map pin icon",
            "value": "MapPinIcon"
        },
        {
            "name": "map icon",
            "value": "MapIcon"
        },
        {
            "name": "maximize 2 icon",
            "value": "Maximize2Icon"
        },
        {
            "name": "maximize icon",
            "value": "MaximizeIcon"
        },
        {
            "name": "meh icon",
            "value": "MehIcon"
        },
        {
            "name": "menu icon",
            "value": "MenuIcon"
        },
        {
            "name": "message circle icon",
            "value": "MessageCircleIcon"
        },
        {
            "name": "message square icon",
            "value": "MessageSquareIcon"
        },
        {
            "name": "mic off icon",
            "value": "MicOffIcon"
        },
        {
            "name": "mic icon",
            "value": "MicIcon"
        },
        {
            "name": "minimize 2 icon",
            "value": "Minimize2Icon"
        },
        {
            "name": "minimize icon",
            "value": "MinimizeIcon"
        },
        {
            "name": "minus circle icon",
            "value": "MinusCircleIcon"
        },
        {
            "name": "minus square icon",
            "value": "MinusSquareIcon"
        },
        {
            "name": "minus icon",
            "value": "MinusIcon"
        },
        {
            "name": "monitor icon",
            "value": "MonitorIcon"
        },
        {
            "name": "moon icon",
            "value": "MoonIcon"
        },
        {
            "name": "more horizontal icon",
            "value": "MoreHorizontalIcon"
        },
        {
            "name": "more vertical icon",
            "value": "MoreVerticalIcon"
        },
        {
            "name": "mouse pointer icon",
            "value": "MousePointerIcon"
        },
        {
            "name": "move icon",
            "value": "MoveIcon"
        },
        {
            "name": "music icon",
            "value": "MusicIcon"
        },
        {
            "name": "navigation 2 icon",
            "value": "Navigation2Icon"
        },
        {
            "name": "navigation icon",
            "value": "NavigationIcon"
        },
        {
            "name": "octagon icon",
            "value": "OctagonIcon"
        },
        {
            "name": "package icon",
            "value": "PackageIcon"
        },
        {
            "name": "paperclip icon",
            "value": "PaperclipIcon"
        },
        {
            "name": "pause circle icon",
            "value": "PauseCircleIcon"
        },
        {
            "name": "pause icon",
            "value": "PauseIcon"
        },
        {
            "name": "pen tool icon",
            "value": "PenToolIcon"
        },
        {
            "name": "percent icon",
            "value": "PercentIcon"
        },
        {
            "name": "phone call icon",
            "value": "PhoneCallIcon"
        },
        {
            "name": "phone forwarded icon",
            "value": "PhoneForwardedIcon"
        },
        {
            "name": "phone incoming icon",
            "value": "PhoneIncomingIcon"
        },
        {
            "name": "phone missed icon",
            "value": "PhoneMissedIcon"
        },
        {
            "name": "phone off icon",
            "value": "PhoneOffIcon"
        },
        {
            "name": "phone outgoing icon",
            "value": "PhoneOutgoingIcon"
        },
        {
            "name": "phone icon",
            "value": "PhoneIcon"
        },
        {
            "name": "pie chart icon",
            "value": "PieChartIcon"
        },
        {
            "name": "play circle icon",
            "value": "PlayCircleIcon"
        },
        {
            "name": "play icon",
            "value": "PlayIcon"
        },
        {
            "name": "plus circle icon",
            "value": "PlusCircleIcon"
        },
        {
            "name": "plus square icon",
            "value": "PlusSquareIcon"
        },
        {
            "name": "plus icon",
            "value": "PlusIcon"
        },
        {
            "name": "pocket icon",
            "value": "PocketIcon"
        },
        {
            "name": "power icon",
            "value": "PowerIcon"
        },
        {
            "name": "printer icon",
            "value": "PrinterIcon"
        },
        {
            "name": "radio icon",
            "value": "RadioIcon"
        },
        {
            "name": "refresh ccw icon",
            "value": "RefreshCcwIcon"
        },
        {
            "name": "refresh cw icon",
            "value": "RefreshCwIcon"
        },
        {
            "name": "repeat icon",
            "value": "RepeatIcon"
        },
        {
            "name": "rewind icon",
            "value": "RewindIcon"
        },
        {
            "name": "rotate ccw icon",
            "value": "RotateCcwIcon"
        },
        {
            "name": "rotate cw icon",
            "value": "RotateCwIcon"
        },
        {
            "name": "rss icon",
            "value": "RssIcon"
        },
        {
            "name": "save icon",
            "value": "SaveIcon"
        },
        {
            "name": "scissors icon",
            "value": "ScissorsIcon"
        },
        {
            "name": "search icon",
            "value": "SearchIcon"
        },
        {
            "name": "send icon",
            "value": "SendIcon"
        },
        {
            "name": "server icon",
            "value": "ServerIcon"
        },
        {
            "name": "settings icon",
            "value": "SettingsIcon"
        },
        {
            "name": "share 2 icon",
            "value": "Share2Icon"
        },
        {
            "name": "share icon",
            "value": "ShareIcon"
        },
        {
            "name": "shield off icon",
            "value": "ShieldOffIcon"
        },
        {
            "name": "shield icon",
            "value": "ShieldIcon"
        },
        {
            "name": "shopping bag icon",
            "value": "ShoppingBagIcon"
        },
        {
            "name": "shopping cart icon",
            "value": "ShoppingCartIcon"
        },
        {
            "name": "shuffle icon",
            "value": "ShuffleIcon"
        },
        {
            "name": "sidebar icon",
            "value": "SidebarIcon"
        },
        {
            "name": "skip back icon",
            "value": "SkipBackIcon"
        },
        {
            "name": "skip forward icon",
            "value": "SkipForwardIcon"
        },
        {
            "name": "slack icon",
            "value": "SlackIcon"
        },
        {
            "name": "slash icon",
            "value": "SlashIcon"
        },
        {
            "name": "sliders icon",
            "value": "SlidersIcon"
        },
        {
            "name": "smartphone icon",
            "value": "SmartphoneIcon"
        },
        {
            "name": "smile icon",
            "value": "SmileIcon"
        },
        {
            "name": "speaker icon",
            "value": "SpeakerIcon"
        },
        {
            "name": "square icon",
            "value": "SquareIcon"
        },
        {
            "name": "star icon",
            "value": "StarIcon"
        },
        {
            "name": "stop circle icon",
            "value": "StopCircleIcon"
        },
        {
            "name": "sun icon",
            "value": "SunIcon"
        },
        {
            "name": "sunrise icon",
            "value": "SunriseIcon"
        },
        {
            "name": "sunset icon",
            "value": "SunsetIcon"
        },
        {
            "name": "table icon",
            "value": "TableIcon"
        },
        {
            "name": "tablet icon",
            "value": "TabletIcon"
        },
        {
            "name": "tag icon",
            "value": "TagIcon"
        },
        {
            "name": "target icon",
            "value": "TargetIcon"
        },
        {
            "name": "terminal icon",
            "value": "TerminalIcon"
        },
        {
            "name": "thermometer icon",
            "value": "ThermometerIcon"
        },
        {
            "name": "thumbs down icon",
            "value": "ThumbsDownIcon"
        },
        {
            "name": "thumbs up icon",
            "value": "ThumbsUpIcon"
        },
        {
            "name": "toggle left icon",
            "value": "ToggleLeftIcon"
        },
        {
            "name": "toggle right icon",
            "value": "ToggleRightIcon"
        },
        {
            "name": "tool icon",
            "value": "ToolIcon"
        },
        {
            "name": "trash 2 icon",
            "value": "Trash2Icon"
        },
        {
            "name": "trash icon",
            "value": "TrashIcon"
        },
        {
            "name": "trello icon",
            "value": "TrelloIcon"
        },
        {
            "name": "trending down icon",
            "value": "TrendingDownIcon"
        },
        {
            "name": "trending up icon",
            "value": "TrendingUpIcon"
        },
        {
            "name": "triangle icon",
            "value": "TriangleIcon"
        },
        {
            "name": "truck icon",
            "value": "TruckIcon"
        },
        {
            "name": "tv icon",
            "value": "TvIcon"
        },
        {
            "name": "twitch icon",
            "value": "TwitchIcon"
        },
        {
            "name": "twitter icon",
            "value": "TwitterIcon"
        },
        {
            "name": "type icon",
            "value": "TypeIcon"
        },
        {
            "name": "umbrella icon",
            "value": "UmbrellaIcon"
        },
        {
            "name": "underline icon",
            "value": "UnderlineIcon"
        },
        {
            "name": "unlock icon",
            "value": "UnlockIcon"
        },
        {
            "name": "upload cloud icon",
            "value": "UploadCloudIcon"
        },
        {
            "name": "upload icon",
            "value": "UploadIcon"
        },
        {
            "name": "user check icon",
            "value": "UserCheckIcon"
        },
        {
            "name": "user minus icon",
            "value": "UserMinusIcon"
        },
        {
            "name": "user plus icon",
            "value": "UserPlusIcon"
        },
        {
            "name": "user x icon",
            "value": "UserXIcon"
        },
        {
            "name": "user icon",
            "value": "UserIcon"
        },
        {
            "name": "users icon",
            "value": "UsersIcon"
        },
        {
            "name": "video off icon",
            "value": "VideoOffIcon"
        },
        {
            "name": "video icon",
            "value": "VideoIcon"
        },
        {
            "name": "voicemail icon",
            "value": "VoicemailIcon"
        },
        {
            "name": "volume 1 icon",
            "value": "Volume1Icon"
        },
        {
            "name": "volume 2 icon",
            "value": "Volume2Icon"
        },
        {
            "name": "volume x icon",
            "value": "VolumeXIcon"
        },
        {
            "name": "volume icon",
            "value": "VolumeIcon"
        },
        {
            "name": "watch icon",
            "value": "WatchIcon"
        },
        {
            "name": "wifi off icon",
            "value": "WifiOffIcon"
        },
        {
            "name": "wifi icon",
            "value": "WifiIcon"
        },
        {
            "name": "wind icon",
            "value": "WindIcon"
        },
        {
            "name": "x circle icon",
            "value": "XCircleIcon"
        },
        {
            "name": "x octagon icon",
            "value": "XOctagonIcon"
        },
        {
            "name": "x square icon",
            "value": "XSquareIcon"
        },
        {
            "name": "x icon",
            "value": "XIcon"
        },
        {
            "name": "youtube icon",
            "value": "YoutubeIcon"
        },
        {
            "name": "zap off icon",
            "value": "ZapOffIcon"
        },
        {
            "name": "zap icon",
            "value": "ZapIcon"
        },
        {
            "name": "zoom in icon",
            "value": "ZoomInIcon"
        },
        {
            "name": "zoom out icon",
            "value": "ZoomOutIcon"
        }
    ]